import { UsersSlotState } from '../models/slots.model';
import RequestCreator from './helpers/requestCreator';

class UsersSlot extends RequestCreator<UsersSlotState> {}

const api = new UsersSlot('/users-slot');
export default api;
